import { useEffect } from 'react';
import { useUser } from '@contexts/UserContext';
import { useAppDispatch, useAppSelector } from '@store';
import { fetchSettings, clearSettings } from '@store/slices/settingsSlice';

export const SettingsInitializer = () => {
  const { user } = useUser();
  const dispatch = useAppDispatch();
  const isLoadingSettings = useAppSelector((state) => state.settings.isLoading);
  const hasFetched = useAppSelector((state) => state.settings.hasFetched);

  useEffect(() => {
    const username = user?.username;

    // Clear settings when user logs out
    if (!username) {
      dispatch(clearSettings());
      return;
    }

    // Fetch settings when user is available and we haven't fetched yet
    // Check isLoadingSettings first to prevent race conditions
    if (!isLoadingSettings && !hasFetched) {
      dispatch(fetchSettings(username));
    }
  }, [user?.username, hasFetched, isLoadingSettings, dispatch]);

  return null;
};
